module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (72).69514509.jpg";